module.exports = __webpack_public_path__ + "img/ding_talk.c6afcdf6.svg";